"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textToolbarFeatureButtons = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var EditorMarks_1 = require("Project/QwilrEditor/Marks/EditorMarks");
exports.textToolbarFeatureButtons = {
    bold: {
        displayName: "Bold",
        icon: react_1.default.createElement(icons_1.Bold, null),
        eventButtonType: EditorTypes_1.MarkType.Bold,
        isActive: makeIsActiveMarkFunction(EditorTypes_1.MarkType.Bold),
    },
    italic: {
        displayName: "Italic",
        icon: react_1.default.createElement(icons_1.Italic, null),
        eventButtonType: EditorTypes_1.MarkType.Italic,
        isActive: makeIsActiveMarkFunction(EditorTypes_1.MarkType.Italic),
    },
    strikethrough: {
        displayName: "Strikethrough",
        icon: react_1.default.createElement(icons_1.Strikethrough, null),
        eventButtonType: EditorTypes_1.MarkType.Strikethrough,
        isActive: makeIsActiveMarkFunction(EditorTypes_1.MarkType.Strikethrough),
    },
    link: {
        displayName: "Link",
        icon: react_1.default.createElement(icons_1.Link, null),
        eventButtonType: EditorTypes_1.InlineType.Link,
        isActive: function () { return false; },
    },
    comment: {
        displayName: "Comment",
        icon: (react_1.default.createElement("div", null,
            react_1.default.createElement(icons_1.AddComment, null))),
        eventButtonType: EditorTypes_1.MarkType.Comment,
        isActive: function () { return false; },
    },
};
function makeIsActiveMarkFunction(markType) {
    return function (editor) {
        var activeMarks = (0, EditorMarks_1.getCurrentMarks)(editor);
        return activeMarks.some(function (m) { return m.type === markType; });
    };
}
